import { Button } from "@chakra-ui/button";

export function PaginationItem({ isCurrent = false, onPageChange, number }) {
  if (isCurrent) {
    return (
      <Button
        size="sm"
        color="#00B2EF"
        width="7"
        height="7"
        minW="unset"
        fontSize='16px'
        fontWeight={400}
        bg="rgba(0, 178, 239, 0.2)"
        borderRadius="4px"
        isDisabled
        _disabled={{
          bg: "rgba(0, 178, 239, 0.2)",
          cursor: "default",
        }}
      >
        {number}
      </Button>
    );
  }

  return (
    <Button
      size="sm"
      width="6"
      color="#5C6066"
      fontSize='16px'
      bg="transparent"
      onClick={() => onPageChange(number)}
    >
      {number}
    </Button>
  );
}
